import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TeletelLifecycleIndex from './Index.vue';

const lifecycleManageMeta = {
  permissions: ['administrator', 'lifecycle_manage'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/customer-lifecycle'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'teletel_lifecycle_settings',
          meta: lifecycleManageMeta,
          component: TeletelLifecycleIndex,
        },
      ],
    },
  ],
};
